/**
 *
 * CartIcon
 *
 */

import React from "react";

import { BagIcon } from "../Icon";
import Button from "../Button";

const CartIcon = (props) => {
  const { className, onClick, cartItems, cart } = props;
  let cartTotal = cart.cartTotal;
  let cartdiscount = cart.cartdiscount || 0;
  const Icon = (
    <span
      className="cart-icon"
      style={{
        position: "relative",
        lineHeight: "100%",
        padding: "8px ",
        //border: "none",
        //background: "transparent",
        //color: "white",//"inherit", //"#323232 !important",
        minWidth: 60,
      }}
    >
      <BagIcon fillcolor={"white"} />
      {cartItems?.length > 0 && (
        <>
          <span
            id="icart_id"
            className="count avail"
            style={{
              display: "flex",
              borderRadius: "16px",
              position: "absolute",
              top: -2,
              right: -4,
              textAlign: "center",
              //width: 20,
              height: 20,
              //backgroundColor: "#ff2950",
              //color: "#fff",
              justifyContent: "center",
              alignItems: "center",

              backgroundColor: "#ffe89a",
              color: "#e96f39",
              padding: 5,
              margin: "0 -42px 0px 0px",
            }}
          >
            {cartTotal &&
              (cartTotal ? cartTotal - (cartdiscount || 0) : "") + " грн."}
          </span>
          {false && (
            <span
              className="cart-badge"
              style={{
                display: "flex",
                borderRadius: "100%",
                fontSize: ".6rem",
                fontWeight: 600,
                position: "absolute",
                top: -2,
                right: -4,
                textAlign: "center",
                width: 20,
                height: 20,
                backgroundColor: "#ff2950",
                color: "#fff",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {cartTotal ? cartTotal - (cartdiscount || 0) : ""}
            </span>
          )}
        </>
      )}
    </span>
  );

  const items = cartItems?.length;

  return (
    <Button
      borderless
      variant="empty"
      className={className}
      ariaLabel={
        items > 0 ? `your cart have ${items} items` : "your cart is empty"
      }
      icon={Icon}
      onClick={onClick}
    />
  );
};

export default CartIcon;
